module.exports = __webpack_public_path__ + "static/media/execute_examReults.d267bbda.png";